const INITIAL_STATE = {
  data: {},
  unattached_payment:{},
  errors: {},
        
}
const addManualyPayment = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'ADD_LOG_PAYMENT_SUCCESSFULLY':
    return { ...INITIAL_STATE, data: action.data }
  case 'ADD_LOG_PAYMENT_FAILED':
    return { ...INITIAL_STATE, errors: action.data }
  case 'ADD_UNATTACHED_PAYMENT_SUCCESSFULLY':
    return { ...INITIAL_STATE, unattached_payment: action.data }
  case 'ADD_UNATTACHED_PAYMENT_FAILED':
    return { ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};
        
export default addManualyPayment;